import Vue from 'vue';
import { getSaProfile, unbindSa} from '../../../services/crmService/mySaService';
import { getSaList } from '../../../services/personnelService/signUpService';
import { activateKeyword }from '../../../services/backendService/keywordService';
// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
//(用於保存共享數據的)
const state = {
  saData: {},
  saList: {},
};

// getters
const getters = {};

// actions
const actions = {
  // 取得我的顧問 Profile
  async getSaProfileHandler({ commit }) {
    const data = await getSaProfile();
    commit('setSaData', data.data);
  },
  // 解除與顧問綁定
  async unbindSaHandler() {
    await unbindSa();
  },
  // 取得顧問列表
  async getSaListHandler({ commit }) {
    const data = await getSaList();
    commit('setSaList', data.data);
  },
   // 傳送開啟聊天室flex-message
   async activateKeywordHandler() {
    await activateKeyword();
  },
};

// mutations
//(用於保存修改共同數據的方法)
const mutations = {
  setSaData(state, data) {
    Vue.set(state, 'saData', data);
  },
  setSaList(state, data) {
    Vue.set(state, 'saList', data.personnel);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};